export default __webpack_public_path__ + "static/media/Shield.0f9a7596.svg";